import {
	getSalesCountryCopy,
	hasSalesCountryCopy,
	type SalesCountryCopyKey,
} from "@/config/sales-country-copy";
import nbReferenceCopy from "@/lib/research/nb-reference-copy.json";
import type { ReferencePeptide } from "@/lib/research/types";
import { getSharedReferenceSequence } from "@/config/shared-runtime-copy";

const classifications: Record<string, string> = nbReferenceCopy;

/** Translate display prose without mutating shared scientific reference data. */
export function localizeReferencePeptide(peptide: ReferencePeptide, locale?: string): ReferencePeptide {
	let classification: string | undefined;
	if (hasSalesCountryCopy(locale)) {
		classification = getSalesCountryCopy(
			locale,
			`reference.${peptide.slug}.classification` as SalesCountryCopyKey,
		);
	}
	if (classification === undefined && locale === "nb") {
		classification = classifications[`reference.${peptide.slug}.classification`];
	}
	const sequence = getSharedReferenceSequence(peptide, locale);
	if (classification === undefined && sequence === peptide.sequence) return peptide;
	return {
		...peptide,
		...(classification === undefined ? {} : { classification }),
		...(sequence === peptide.sequence ? {} : { sequence }),
	};
}
